import { numberWithCommas } from 'utils/StringUtil';
import { Currency } from 'core';
import _ from 'lodash';

export const divideValue = (numerator, denominator) => {
  if (denominator === 0) {
    return 0;
  }
  return _.floor(numerator / denominator, 2);
};

export const percentDecorator = (data) => {
  return fractionDecorator(data) + '%';
};

export const commaDecorator = (data) => {
  return numberWithCommas(data);
};

export const fractionDecorator = (data: number) => {
  return commaDecorator(_.floor(data, 2).toFixed(2));
};

export const costDecorator = (data) => {
  return `${commaDecorator(_.floor(data, 2).toFixed(2))}`;
};

export const totalCostDecorator = (currency, data) => {
  let priceValue;
  switch (currency) {
    case Currency.MYR:
    case Currency.USD:
    case Currency.NTD:
      priceValue = _.floor(data, 2).toFixed(2);
      break;
    default:
      priceValue = Math.floor(data).toFixed();
  }
  return `${numberWithCommas(priceValue)}`;
};

export const emptyReportRecord = (dimensionName) => {
  return {
    dimensionName: dimensionName,
    agcProfit: 0,
    clicks: 0,
    complete: 0,
    conv_1: 0,
    conv_7: 0,
    convs: 0,
    dataCost: 0,
    firstQuartile: 0,
    midpoint: 0,
    thirdQuartile: 0,
    impres: 0,
    incentive: 0,
    mediaCost: 0,
    mediaSpent: 0,
    skipCount: 0,
    spent: 0,
    sysProfit: 0,
    underBidFloor: 0,
    view: 0,
    viewable: 0,
    winTotal: 0,
    beacon: 0,
    messageCount: 0,
    tags: []
  };
};
